import styles from "./MeusEnderecos.module.scss";
import {useEffect,useState} from "react";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import {IEnderecoUser} from "shared/interfaces/IEnderecoUser";
import {EnderecoItem} from "shared/components/enderecoitem/EnderecoItem";
import {buscarEnderecos,excluirEndereco,definirComoPrincipal} from "shared/services/api/endereco.api";
import {MapPin,Plus} from "lucide-react";
import {useNavigate,useLocation} from "react-router-dom";

interface CadastroLojaState{
  selecionarEndereco?:boolean;
  returnTo?:string;
  origem?:string;
  dadosInformacoes?:unknown;
  dadosRepresentante?:unknown;
  dadosEndereco?:unknown;
  abaRetorno?:string;
}

export const MeusEnderecos:React.FC=()=>{
  const [enderecos,setEnderecos]=useState<IEnderecoUser[]>([]);
  const [loading,setLoading]=useState(true);
  const navigate=useNavigate();
  const location=useLocation();
  const state=location.state as CadastroLojaState|null;
  const selecionarEndereco=state?.selecionarEndereco;
  const returnTo=state?.returnTo;
  const origem=state?.origem;
  const dadosInformacoes=state?.dadosInformacoes;
  const dadosRepresentante=state?.dadosRepresentante;
  const dadosEndereco=state?.dadosEndereco;

  const carregarEnderecos=async()=>{
    try{
      setLoading(true);
      const lista=await buscarEnderecos();
      setEnderecos(lista);
    }catch(error){
      console.error("Erro ao carregar endereços:",error);
    }finally{
      setLoading(false);
    }
  };

  useEffect(()=>{
    carregarEnderecos();
  },[]);

  const handleDefinirPrincipal=async(id:string)=>{
    try{
      await definirComoPrincipal(id);
      await carregarEnderecos();
    }catch(error){
      console.error("Erro ao definir principal:",error);
    }
  };

  const handleExcluir=async(id:string)=>{
    try{
      await excluirEndereco(id);
      await carregarEnderecos();
    }catch(error){
      console.error("Erro ao excluir endereço:",error);
    }
  };

  const handleSelecionarEndereco=(enderecoSelecionado:IEnderecoUser)=>{
    if(!returnTo)return;

    if(origem==="cadastro-loja"){
      navigate(returnTo,{
        state:{
          origem:"cadastro-loja",
          enderecoId:enderecoSelecionado.id,
          dadosInformacoes,
          dadosRepresentante,
          dadosEndereco:enderecoSelecionado,
          abaRetorno:"representante",
        },
      });
      return;
    }

    navigate(returnTo,{
      state:{
        enderecoSelecionado,
      },
    });
  };

  const handleCadastrarEndereco=()=>{
    if(origem==="cadastro-loja"){
      navigate("/cadastroendereco",{
        state:{
          origem:"cadastro-loja",
          returnTo,
          selecionarEndereco:true,
          dadosInformacoes,
          dadosRepresentante,
          dadosEndereco,
          abaRetorno:"endereco",
        },
      });
      return;
    }

    navigate("/cadastroendereco");
  };

  return(
    <PageContainer
      title="Meus Endereços"
      showDesktopSearch={false}
      icon={<MapPin size={18}/>}
      showLogo
      logo={<img src="/imagens/menuLogoBranco.png" alt="Move"/>}
    >
      <div className={styles.page}>
        <div className={styles.cabecalho}>
          <div>
            <h2 className={styles.titulo}>Endereços salvos</h2>
            <p className={styles.descricao}>Selecione o endereço que deseja utilizar</p>
          </div>

          <span className={styles.contador}>
            {enderecos.length} {enderecos.length===1?"endereço":"endereços"}
          </span>
        </div>

        {loading&&(
          <p className={styles.loading}>Carregando endereços...</p>
        )}

        {!loading&&enderecos.length===0&&(
          <div className={styles.containerVazio}>
            <div className={styles.containerImgVazio}>
              <img
                className={styles.imgVazio}
                src="/imagens/enderecosVazio.png"
                alt="Nenhum endereço cadastrado"
              />
            </div>

            <p className={styles.fraseVazio}>
              Nenhum endereço
              <br/>
              encontrado
            </p>

            <div className={styles.containerLinkAdd}>
              <p>
                <span onClick={handleCadastrarEndereco} className={styles.linkAdd}>
                  Clique aqui
                </span>{" "}
                para cadastrar um endereço
              </p>
            </div>
          </div>
        )}

        {!loading&&enderecos.length>0&&(
          <div className={styles.listaEnderecos}>
            {enderecos.map((endereco)=>(
              <EnderecoItem
                key={endereco.id}
                endereco={endereco}
                onDefinirPrincipal={handleDefinirPrincipal}
                onExcluir={handleExcluir}
                onSelect={selecionarEndereco?handleSelecionarEndereco:undefined}
              />
            ))}

            <div className={styles.containerLinkAdd} onClick={handleCadastrarEndereco}>
              <Plus size={16}/>
              <span className={styles.addEndereco}>Adicionar novo endereço</span>
            </div>
          </div>
        )}
      </div>
    </PageContainer>
  );
};
